import {KeasyBootstrap} from './keasy-components/keasy-bootstrap';

declare let window: KeasyBootstrap;

const DARK_MODE_CLASS = "dark";
const LIGHT_MODE_CLASS = "light";

window.toggleColorScheme = (): void => {
    const element = document.querySelector('html');

    if (!element) {
        return;
    }

    element.classList.toggle(DARK_MODE_CLASS);
    storeColorScheme(element.classList.contains(DARK_MODE_CLASS) ? 'dark' : 'light');
}

function updateColorScheme(): void {
    if (!document.querySelector('html')) {
        return;
    }

    const classList = document.querySelector('html')?.classList;

    if (!classList) {
        return;
    }

    if (classList.contains(DARK_MODE_CLASS) || classList.contains(LIGHT_MODE_CLASS)) {
        return;
    }

    if (getColorScheme() === 'dark' || (!getColorScheme() && getSystemPreference() === 'dark')) {
        classList.add(DARK_MODE_CLASS);
        return;
    }

    classList.remove(DARK_MODE_CLASS);
}

function storeColorScheme(mode: 'dark' | 'light'): void {
    localStorage.setItem('ColorScheme', JSON.stringify({
        mode: mode
    }));
}

function getSystemPreference(): 'dark' | 'light' | undefined {
    if (!window.matchMedia) {
        return;
    }

    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }

    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
    }
}

function getColorScheme(): 'dark' | 'light' | undefined {
    const store = localStorage.getItem('ColorScheme');

    if (!store) {
        return;
    }

    return JSON.parse(store).mode;
}

function handleReferrer(): void {
    if (!document.referrer || !document.querySelector('html')) {
        return;
    }

    const dataSet = document.querySelector('html')?.dataset;

    if (!dataSet) {
        return;
    }

    const referrerUrl = new URL(document.referrer);
    const currentUrl = document.location;

    if (currentUrl.pathname === referrerUrl.pathname) {
        dataSet.sameReferrer = '';
        return;
    }

    dataSet.referrer = referrerUrl.pathname;
}

updateColorScheme();
handleReferrer();

if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('load', updateColorScheme);
}